import src from "IMAGE";
export default { src, width: 500, height: 500, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
